// extracted by mini-css-extract-plugin
module.exports = {"navItem":"AuthenticatedHeaderMenu_navItem__X2lgq","dropdown":"AuthenticatedHeaderMenu_dropdown__ktcqo"};